__webpack_require__.p = "https://cdn.m2.ru/assets/gatsby-party/custom/prod/moskva/";